import { SET_LOGINED, SET_USERINFO, SET_CALLING_CODE, SET_SHOW_AREA, SET_UNREAD_NOTIFICATIONS, LINKS, SET_LOGGING_IN } from './../ActionTypes'
import { Action, CallingCode } from 'types/interface'
import { SET_MENU } from 'store/ActionTypes'
import { isLogined } from 'service/sign'
import { getStorage } from 'utils/localstorage'
import { UserInfo } from 'utils/constant'

export interface UserState {
  showMenu: boolean
  logined: boolean
  userInfo: any
  callingCode: CallingCode | null
  showArea: boolean,
  links: any,
  unreadNotifications: boolean,
  isLoggingIn: boolean,
}

const defaultState: UserState = {
  showMenu: false,
  logined: isLogined(),
  userInfo: getStorage(UserInfo) || {},
  callingCode: null,
  showArea: false,
  links:{},
  unreadNotifications: false,
  isLoggingIn: false,
}

const actionToState = {
  [SET_MENU]: 'showMenu',
  [SET_LOGINED]: 'logined',
  [SET_USERINFO]: 'userInfo',
  [SET_CALLING_CODE]: 'callingCode',
  [SET_SHOW_AREA]: 'showArea',
  [LINKS]: 'links',
  [SET_UNREAD_NOTIFICATIONS]: 'unreadNotifications',
  [SET_LOGGING_IN]: 'isLoggingIn',
}

export default (state = defaultState, action: Action) => {
  const key = actionToState[action.type]
  if (key) {
    return Object.assign({}, state, {
      [key]: action.value
    })
  }
  return state
}
